export const IMAGE_PLACEHOLDER_URL =
  'https://seedtrace-prd.imgix.net/defaults/placeholder-image.png';
